const replaceSpaceWithDash = (string = '') => string.toLowerCase().replace(/ /g, '-')

module.exports = {
  replaceSpaceWithDash
}
